import React from 'react';
import Categories from '../Home/Categories/Categories';

const ProductsCategory = () => {
    return (
        <div className='mb-16'>
            <Categories></Categories>
        </div>
    );
};

export default ProductsCategory;